import { HttpService } from 'services/http';


export const getProductsListByClientId = (clientId: number, queryParams: object) => HttpService.get(`/v2/clients/${clientId}/products`, queryParams);

